import { useEffect } from 'react';

import { debounce } from 'lodash-es';

import { useAppDispatch } from 'src/app/store';
import { SearchTypeahead } from 'src/common/SearchTypeahead';
import { setVehicleSearchTerm } from 'src/features/fleet/fleet.slice';
import { VehicleForm } from 'src/features/fleet/VehicleForm/VehicleForm';

export function VehicleManagementRouteActions() {
  const dispatch = useAppDispatch();
  const debounceSearch = debounce(handleSearch, 300);

  function handleSearch(term: string) {
    dispatch(setVehicleSearchTerm(term));
  }

  useEffect(() => {
    return () => {
      dispatch(setVehicleSearchTerm(''));
    };
  }, [dispatch]);

  return (
    <div className="flex items-center gap-2">
      <VehicleForm />
      <SearchTypeahead
        onChange={debounceSearch}
        placeholder="Search vehicles"
      />
    </div>
  );
}
